import type { ResultPageView } from "./_types";
import logEvent from "./logEvent";
import type { LoggingEvent } from './logEvent'


/**
 *
 * @param props This object contains
 */

const resultPageView = ({ agent, owner, type, category, result_id, portfolio_id, place }: ResultPageView) => {
  // UA
  // This is handled by the default pageView

  // Tag Manager
  let layerUpdate: LoggingEvent = { event: "result_page_view" };

  if (agent) layerUpdate.agent = agent;
  if (owner) layerUpdate.owner = owner;
  if (type) layerUpdate.type = type;
  if (category) layerUpdate.category = category;
  if (result_id) layerUpdate.result_id = result_id;
  if (place) layerUpdate.place = place;
  if (portfolio_id) layerUpdate.portfolio_id = portfolio_id;

  logEvent(layerUpdate)
};

export default resultPageView;
